import React, { useState, useEffect } from "react";
import { DropDown } from "../../commons";
import "react-datepicker/dist/react-datepicker.css";
import ReportsDateSelect from "../../commons/ReportsDateSelect/ReportsDateSelect";
import { useLocation } from "react-router-dom";
import { DropDownType } from "../../../commonTypes/clientDirectoryTypes";
import { BatchManagementItem } from "../../../redux/clientSettings/clientSettingTypes";

type AppProps = {
  startDate?: any;
  endDate?: any;
  allStockItemList: any;
  handleStartDateChange: (date: any) => void;
  handleEndDateChange: (date: any) => void;
  handleSubmitData?: (data: any) => void;
  toggle: boolean;
  setToggle: (data: boolean) => void;
  stockItemName: DropDownType;
  setStockItemName: React.Dispatch<React.SetStateAction<DropDownType>>;
  mappedStockBatchList: BatchManagementItem[] | [];
};

const BatchVoucherHeader = ({
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  handleSubmitData,
  allStockItemList,
  toggle,
  setToggle,
  stockItemName,
  setStockItemName,
  mappedStockBatchList,
}: AppProps) => {
  const search = useLocation().search;
  const redirectStockItemName = localStorage.getItem("stock_item_name");
  const sku_id = new URLSearchParams(search).get("sku_id");
  const [batchId, setBatchId] = useState({
    value: "",
    label: "Select Batch ID..",
  });
  const [batchDetails, setBatchDetails] = useState({
    manufacturing: "",
    expiry: ""
  })
  const option: any = allStockItemList?.map((data: any) => {
    return {
      value: data.stock_item_id,
      label: data.stock_item_name,
    };
  });
  const batchIDOptions = mappedStockBatchList?.map((data: any) => {
    return{
        value: data?.batch_id,
        label: data?.batch_number,
        manufacturingDate: data?.manufacturing_date,
        expiryDate: data?.expiry_date,
    }
  })

  useEffect(() => {
    if (redirectStockItemName && sku_id) {
      setStockItemName({
        value: sku_id,
        label: redirectStockItemName,
      });
    }
  }, [redirectStockItemName]);

  useEffect(() => {
    if(stockItemName?.value){
      setBatchId({
        value: "",
        label: "Select Batch ID..",
      })
    }
  }, [stockItemName?.value]);  

  const getBatchVoucherReport = () => {
    if (stockItemName?.value) {
      const data = {
        skuId: stockItemName?.value,
        stockItemName: stockItemName?.label,
        batchId: batchId?.value,
        batchName: batchId?.label,
        batchMfgDate: batchDetails?.manufacturing,
        batchExpDate: batchDetails?.expiry,
      };
      handleSubmitData?.(data);
    }
  };

  const handleSetStockItemName = (mode: any) => {
    setStockItemName({
      value: mode?.value,
      label: mode?.label,
    });
  };

  const handleSetBatchIdName = (mode: any) => {
    setBatchId({
        value: mode?.value,
        label: mode?.label,
    })
    setBatchDetails({
      manufacturing: mode?.manufacturingDate,
      expiry: mode?.expiryDate,
    })
  }


  return (
    <div className="d-flex justify-content-start align-items-center">
      <div className="form-group">
        <label>Date</label>
        <div>
          <ReportsDateSelect
            setToggle={setToggle}
            toggle={toggle}
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
          />
        </div>
      </div>
      <div className="col-md-3 form-group">
        <label>Stock Item</label>
        <div>
          <DropDown
            extraClasses="zindex-2"
            options={option}
            value={stockItemName}
            handleChange={handleSetStockItemName}
          />
        </div>
      </div>
      <div className="col-md-3 form-group"
      style={{
        marginLeft: "-15px"
      }}
      >
        <label>Batch ID</label>
        <div>
          <DropDown
            extraClasses="zindex-2"
            options={batchIDOptions}
            value={batchId}
            handleChange={handleSetBatchIdName}
          />
        </div>
      </div>
      <div className="col-md-3 mt-2">
        <button
          className="btn btn-primary"
          onClick={getBatchVoucherReport}
          disabled={
            !startDate?.length || !endDate?.length || !stockItemName?.value || !batchId?.value
          }
        >
          Get Report
        </button>
      </div>
    </div>
  );
};

export default BatchVoucherHeader;
